import { DEVICE_COMPLIANCE_SCORE_STATUS } from '../../constants/compliance/compliance.constants';

export const getCyberScoreColorCssClass = (cyberScore: number) =>
  cyberScore >= DEVICE_COMPLIANCE_SCORE_STATUS.PASS.MIN &&
  cyberScore <= DEVICE_COMPLIANCE_SCORE_STATUS.PASS.MAX
    ? 'text-success'
    : cyberScore >= DEVICE_COMPLIANCE_SCORE_STATUS.WARNING.MIN &&
        cyberScore <= DEVICE_COMPLIANCE_SCORE_STATUS.WARNING.MAX
      ? 'text-warning'
      : 'text-danger';

export const getComplianceFactorNameBasedOnQuicksightParam = (
  factorName: string
) => {
  let factor = '';
  switch (factorName) {
    case 'Password':
      factor = 'passWord';
      break;
    case 'Password Age':
      factor = 'passwordAge';
      break;
    case 'Screenlock':
      factor = 'screenLock';
      break;
    case 'Disk Encryption':
      factor = 'diskEncryption';
      break;
    case 'Antivirus Enabled':
      factor = 'antivirusEnabled';
      break;
    case 'Antivirus Auto Update':
      factor = 'antivirusAutoUpdate';
      break;
    case 'Antispyware':
      factor = 'antiSpyware';
      break;
    case 'Firewall':
      factor = 'firewall';
      break;
    case 'Peer-to-Peer':
      factor = 'peerToPeer';
      break;
    case 'OS Auto Updates':
      factor = 'osAutoUpdates';
      break;
    case 'WiFi':
      factor = 'wifi';
      break;
    case 'VPN Connected':
      factor = 'vpnConnected';
      break;
    case 'Critical Updates Installed':
      factor = 'criticalUpdatesInstalled';
      break;
    case 'Non-Critical Updates Installed':
      factor = 'nonCriticalUpdatesInstalled';
      break;
    case 'OS Class':
      factor = 'osClass';
      break;
    case 'OS Supported':
      factor = 'osSupported';
      break;
    case 'Data Leakage':
      factor = 'dataLeakage';
      break;
    case 'Remediation Declined':
      factor = 'remediationDeclined';
      break;
    case 'Phishing':
      factor = 'phishing';
      break;
    case 'SAT':
      factor = 'sat';
      break;
    case 'New Processes':
      factor = 'newProcesses';
      break;
    case 'New Applications':
      factor = 'newApplications';
      break;
    default:
      factor = factorName;
      break;
  }
  return factor;
};
